import { Routes, Route, Navigate, Outlet } from "react-router-dom";
import Login from "../../pages/Login";
import Dashboard from "../../pages/Dashboard";
import CreateAgents from "../../pages/AgentsDetails/CreateAgents";
import EditAgentsDetails from "../../pages/AgentsDetails/EditAgentsDetails";
import ViewAgentsDetails from "../../pages/AgentsDetails/ViewAgentsDetails";
import ManageAgents from "../../pages/ManageAgents";
import CreateCustomers from "../../pages/CustomersDetails/CreateCustomers";
import CustomersList from "../../pages/CustomersDetails/CustomersList";
import Reports from "../../pages/Reports";
import EditCustomerDetails from "../../pages/CustomersDetails/EditCustomerDetails";
import TicketsList from "../../pages/TicketsDetails/TicketList";
import CreateTickets from "../../pages/TicketsDetails/CreateTicket";
import UserDetails from "../../pages/UserDetails";
import ForgotPassword from "../../pages/Login/ForgotPassword";
import ViewTicketHistory from "../../pages/TicketsDetails/ViewTicketHistory";
import ReopenTicket from "../../pages/TicketsDetails/ReopenTicket";
import CreateTemplate from "../../pages/Templates/CreateTemplate";
import EscalationsReport from "../../pages/EscalationsReportPages/EscalationsReport";
import CustomerDashboard from "../../pages/customerDashboard";
import { useAuth } from "../../context/AuthContext";
import { useEffect, useState } from "react";

import EscalationsTicket from "../../pages/EscalationsTicket";
import CallRecordings from "../../pages/CallRecordings";

import NotificationDropdown from "../../component/Notification";
import UserLogs from "../../pages/UserLogs";
// const useAuth = () => {
//   const token = localStorage.getItem("authToken");
//   const expiry = localStorage.getItem("tokenExpiry");

//   return token && expiry && new Date().getTime() < parseInt(expiry);
// };

const PrivateRoute = () => {
  const { IsAuthenticateUser } = useAuth();
  const [isLoading, setIsLoading] = useState(true);
  const [isAllowed, setIsAllowed] = useState(false);

  useEffect(() => {
    const checkAuth = async () => {
      const result = await IsAuthenticateUser();
      setIsAllowed(result);
      setIsLoading(false);
    };
    checkAuth();
  }, [IsAuthenticateUser]);

  if (isLoading) return <div>Checking authentication...</div>;

  return isAllowed ? <Outlet /> : <Navigate to="/" replace />;
};

const AdminRoute = () => {
  const { IsAuthenticateUser, authUser } = useAuth();
  const [isLoading, setIsLoading] = useState(true);
  const [isAllowed, setIsAllowed] = useState(false);

  useEffect(() => {
    const checkAdmin = async () => {
      const result = await IsAuthenticateUser();
      const user = authUser || JSON.parse(localStorage.getItem("user"));
      const isAdmin = result && user?.isAdmin;
      setIsAllowed(isAdmin);
      setIsLoading(false);
    };
    checkAdmin();
  }, [IsAuthenticateUser, authUser]);

  if (isLoading) return <div>Checking admin access...</div>;

  return isAllowed ? <Outlet /> : <Navigate to="/dashboard" replace />;
};

const RedirectByUserType = () => {
  const { IsAuthenticateUser } = useAuth();
  const [isLoading, setIsLoading] = useState(true);
  const [isAllowed, setIsAllowed] = useState(false);

  useEffect(() => {
    const check = async () => {
      const result = await IsAuthenticateUser();
      setIsAllowed(result);
      setIsLoading(false);
    };
    check();
  }, [IsAuthenticateUser]);

  if (isLoading) return <div>Redirecting...</div>;

  return isAllowed ? <Navigate to="/dashboard" replace /> : <Login />;
};
export default function NavRouting() {
  return (
    <Routes>
      {/* Public Routes */}
      <Route path="/" element={<RedirectByUserType />} />
      <Route path="/forgot-password/:token" element={<ForgotPassword />} />

      {/* Protected Routes */}
      <Route element={<PrivateRoute />}>
        <Route path="/customer-dashboard/:code" element={<CustomerDashboard />} />
        <Route path='/dashboard' element={<Dashboard />} />

        <Route path='/create-ticket' element={<CreateTickets />} />
        <Route path='/view-ticket-history/:ticket_no' element={<ViewTicketHistory />} />
        <Route path='/reopen-ticket/:ticket_no' element={<ReopenTicket />} />
        <Route path='/tickets-list' element={<TicketsList />} />

        <Route path='/create-customer' element={<CreateCustomers />} />
        <Route path='/edit-customer-details/:cust_code' element={<EditCustomerDetails />} />
        <Route path='/customers-list' element={<CustomersList />} />
        <Route path='/reports' element={<Reports />} />
        <Route path="/create-customer" element={<CreateCustomers />} />
        <Route
          path="/edit-customer-details/:cust_code"
          element={<EditCustomerDetails />}
        />

        <Route path="/notification" element={<NotificationDropdown />} />



        <Route path="/escalations-ticket" element={<EscalationsTicket />} />

        <Route path="/customers-list" element={<CustomersList />} />
        <Route path="/reports" element={<Reports />} />

        <Route path='/user-details' element={<UserDetails />} />
        <Route path='/user-logs' element={<UserLogs />} />

        <Route path='/escalations-report' element={<EscalationsReport />} />
        <Route element={<AdminRoute />}>

          <Route element={<AdminRoute />}>

            <Route path='/create-agents' element={<CreateAgents />} />
            <Route path='/edit-agents-details' element={<EditAgentsDetails />} />
            <Route path='/view-agents-details/:code' element={<ViewAgentsDetails />} />
            <Route path='/manage-agents' element={<ManageAgents />} />
            <Route path='/create-template' element={<CreateTemplate />} />
          </Route>

          {/*<Route path="*" element={<NoPage />} /> */}

          {/*<Route path="*" element={<NoPage />} /> */}
        </Route>
      </Route>

      <Route path="/call-records" element={<CallRecordings />} />
      {/* Optional 404 Route */}
      {/* <Route path="*" element={<NoPage />} /> */}
    </Routes >

  );
}
